/**
 * Cypress-compatible version of useRefreshToken.
 * Returns no-op functions since Cypress doesn't use Auth0.
 * getToken and setToken are provided by useTokenRef in UserContext.
 *
 * @returns {Object} - { refreshToken, refreshTokenAsync }
 */
export const useRefreshTokenCypress = () => {
  return {
    refreshToken: () => Promise.resolve(null),
    refreshTokenAsync: () => {},
  };
};
